import { TermViewer } from '@/components/organisms/TermViewer';
import { SEOHead } from '@/components/atoms/SEOHead';

/**
 * 이용약관 — sisegonggan.terms 테이블의 type='service' 최신 활성 버전.
 * 어드민 → 약관 관리에서 등록/수정.
 */
export function TermsPage() {
  return (
    <>
      <SEOHead
        title="이용약관"
        description="시세공간 서비스 이용약관 안내"
        canonical="/terms"
      />
      <TermViewer type="service" fallbackTitle="이용약관" />
    </>
  );
}
